import * as types from '../../actionTypes'

const intitialState = {
  isLoading: false,
  subscriptions: new Map(),
  selectedSubscriptionId: null,
  error: null,
}

export default (state = intitialState, action) => {
  switch (action.type) {
    case types.FETCHING_SUBSCRIPTIONS:
      return {
        ...state,
        isLoading: true,
      }
    case types.FETCHING_SUBSCRIPTIONS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      }
    case types.REPLACE_SUBSCRIPTION:
      const newSubscriptions = new Map(state.subscriptions)
      newSubscriptions.set(
        action.subscription.id.toString(),
        action.subscription,
      )
      return {
        ...state,
        subscriptions: newSubscriptions,
        isLoading: false,
        error: null,
      }
    case types.SET_SELECTED_SUBSCRIPTION:
      if (!state.subscriptions.get(action.subscriptionId.toString()))
        return {
          ...state,
          selectedSubscriptionId: null,
        }
      else
        return {
          ...state,
          selectedSubscriptionId: action.subscriptionId.toString(),
        }
    case types.SET_SUBSCRIPTIONS_SUCCESS:
      const mapItems = action.subscriptions.map(i => [i.id.toString(), i])
      return {
        ...state,
        isLoading: false,
        subscriptions: new Map(mapItems),
        error: null,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/css-admin/subscriptionManager/subscriptionManager.js